export default __webpack_public_path__ + "static/media/firewood.141cde31.jpg";